import React from 'react';
import '../styles/ClaimResult.css';


const RadarEvidenceBlock = ({ id, icon, title, summary }) => {
  return (
    <div id={id} className="radar-section-anchor radar-explainer">
      <h4>{icon} {title}</h4>
      <p><strong>Summary:</strong> {summary}</p>
      
    </div>
  );
};

export default RadarEvidenceBlock;

